import { tokens } from '@welbe/web-design-system';
import styled from 'styled-components';

export const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	background-color: ${tokens.color_white};
	padding: 0 20px 20px;
	gap: 40px;
`;

export const LoadingContainer = styled.div`
	box-sizing: border-box;
	display: flex;
	flex-direction: column;
	gap: 40px;
	padding: 0px 20px 20px;
	background-color: ${tokens.color_white};
	width: 100%;
`;

export const LoadingButtonsContainer = styled.div`
	display: flex;
	gap: 15px;
`;

export const Container = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;
	padding: 0px 20px 20px;
	background-color: ${tokens.color_white};
`;

export const ButtonsContainer = styled.div`
	display: flex;
	gap: 10px;
	flex-wrap: wrap;
`;

export const ActivityContainer = styled.div`
	display: grid;
	grid-template-columns: 1fr auto 2fr;
	gap: 40px;
	background-color: ${tokens.color_gray_light};
	border-radius: 6px;
	padding: 20px;
`;

export const EmptyActivityContainer = styled.div`
	background-color: ${tokens.color_gray_light};
	border-radius: 6px;
	padding: 20px;
	display: flex;
	align-items: center;
	gap: 10px;
`;
